'use client'

import {
  OrganizationChannel,
  OrganizationTypeChannel,
  TeamChannel,
  UserChannel,
} from '@mntn-dev/realtime-updates-types'

import type { SessionId } from '@mntn-dev/domain-types'
import { useHandleAllMessages } from '@mntn-dev/realtime-updates-service'
import type { PropsWithChildren } from 'react'
import { trpcReactClient } from '~/app/_trpc/trpc-react-client.ts'
import { usePrincipal } from '~/hooks/secure/use-principal.ts'
import { realtimeUpdateMessageHandler } from '~/utils/realtime-update-message-handler.ts'

const RealtimeUpdatesHandler = ({
  children,
  sessionId,
}: PropsWithChildren<{ sessionId: SessionId }>) => {
  const {
    principal: { organizationType, teamIds, userId, organizationId },
  } = usePrincipal()

  const channelNames = [
    OrganizationChannel(organizationId),
    OrganizationTypeChannel(organizationType),
    ...teamIds.map(TeamChannel),
    UserChannel(userId),
  ]

  const messageHandler = realtimeUpdateMessageHandler(
    trpcReactClient.useUtils(),
    sessionId
  )

  useHandleAllMessages(channelNames, messageHandler)

  return <>{children}</>
}

export { RealtimeUpdatesHandler }
